<template>
	<div class="widgetText" @click="selectCurWidget" ref="myDOM"></div>
</template>

<script lang="ts">
import getTextSize from '@/util/getTextSize';
import { defineComponent, inject, PropType, reactive, ref, onMounted, watch } from 'vue';
import { dataKey, ListWidget, Ornt, State, WidgetText, widgetType } from '../types';
import apportion from '../util/apportion';

export default defineComponent({
	props: {
		me: { type: Object as PropType<WidgetText>, required: true },
		parentType: { type: String, required: true },
	},
	setup(props) {
		const myDOM = ref<HTMLElement>(); // 指代当前组件所在的节点
		const me = reactive(props.me);
		const state: State = inject<any>(dataKey.STATE);
		const parentType = ref(props.parentType);

		// 处理选中
		const selectCurWidget = (e: MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();
			state.curWidget = me;
		};

		// 处理该组件的属性
		onMounted(() => {
			const target = myDOM.value as HTMLElement;
			const rootWidget = state.rootWidget as ListWidget;
			let lastFontSize = me.attrs.font.size;
			let lastLineLimit = me.attrs.lineLimit;
			let lastMinScaleFactor = me.attrs.minimumScaleFactor;
			watch(
				me,
				() => {
					// width、height
					const realHeight = me.size.height;
					const realWidth = me.size.width;
					target.style.width = realWidth + 'px';
					target.style.height = realHeight + 'px';

					// text
					if (target.innerText !== me.attrs.text) {
						target.innerText = me.attrs.text;
						apportion(rootWidget);
					}

					// minimumScaleFactor
					if (lastMinScaleFactor != me.attrs.minimumScaleFactor) {
						lastMinScaleFactor = me.attrs.minimumScaleFactor;
						apportion(rootWidget);
					}
					let realFontSize = me.attrs.font.size;
					const minFontSize = lastMinScaleFactor * realFontSize;
					let computedHeight = getTextSize(me.attrs.text, Ornt.Y, { width: realWidth }, realFontSize);
					while (computedHeight > realHeight && realFontSize > minFontSize) {
						realFontSize--;
						computedHeight = getTextSize(me.attrs.text, Ornt.Y, { width: realWidth }, realFontSize);
					}

					// font：size、type
					target.style.fontSize = realFontSize + 'px';
					target.style.lineHeight = realFontSize + 'px';
					if (lastFontSize != me.attrs.font.size) {
						lastFontSize = me.attrs.font.size;
						apportion(rootWidget);
					}

					// lineLimit
					if (lastLineLimit != me.attrs.lineLimit) {
						lastLineLimit = me.attrs.lineLimit;
						apportion(rootWidget);
					}

					// textColor、textOpacity
					target.style.color = me.attrs.textColor;
					target.style.opacity = me.attrs.textOpacity + '';

					// shadowColor、shadowOffset、shadowRadius
					const x = me.attrs.shadowOffset.x;
					const y = me.attrs.shadowOffset.y;
					const r = me.attrs.shadowRadius;
					const c = me.attrs.shadowColor;
					const shadowValue = `${x}px ${y}px ${r}px ${c}`;
					target.style.textShadow = shadowValue;

					// alignText
					if (parentType.value === widgetType.LIST) {
						target.style.alignSelf = me.attrs.alignText;
					} else {
						target.style.alignSelf = 'flex-start';
					}

					// 文本溢出处理
					const lineCount = Math.ceil(realHeight / realFontSize);
					target.style.webkitLineClamp = lineCount + '';
				},
				{ deep: true, immediate: true }
			);
		});

		return { selectCurWidget, myDOM };
	},
});
</script>

<style scoped>
.widgetText {
	word-wrap: break-word;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
